import React from 'react';
import { ReactTelemetryContext, TelemetryContext } from '../telemetry/TelemetryContext';
import { BaseTelemetryEvent, telemetrySender, TelemetryValueHandling, ValidTelemetryEvent } from '../telemetry/TelemetrySender';

export type PartialEvent<T extends BaseTelemetryEvent> = Partial<Omit<ValidTelemetryEvent<T>, 'type'>>
export type UseTelemetrySenderPartial<T extends BaseTelemetryEvent> = BaseTelemetryEvent & PartialEvent<T>

export function useTelemetrySender<T extends BaseTelemetryEvent>(eventDefinition: UseTelemetrySenderPartial<T>, valueHandling: TelemetryValueHandling = 'remove', contextOverrides?: Partial<TelemetryContext>) {
  const baseContext = React.useContext(ReactTelemetryContext);
  const context = React.useRef({ ...baseContext, ...contextOverrides });

  React.useEffect(() => { context.current = { ...baseContext, ...contextOverrides } }, [baseContext, contextOverrides])

  const sendEvent = React.useCallback(
    (event?: PartialEvent<T>) => {
      try {
        telemetrySender.sendEvent({ ...eventDefinition, ...event }, context.current, valueHandling)
      } catch (_) {
        return;
      }
    },
    [eventDefinition, valueHandling]
  );
  return sendEvent;
}
